import * as React from "react"
import * as ReactDom from "react-dom"
import Landing from "../components/views/landing";
import { requestPageData } from "../services/api";
import { checkLang } from "../services/general";

export const page = async () => {
    const landingContainer = document.getElementById('landing')
    const LANDINGINFO = window.drupalSettings.react.node || await requestPageData({ content: "partner", nid: landingContainer.dataset.nid, langcode: checkLang() })
    ReactDom.render(<Landing  data={LANDINGINFO} />, landingContainer)
}